import { render, staticRenderFns } from "./staffTenTe.vue?vue&type=template&id=78b39981&scoped=true&"
import script from "./staffTenTe.vue?vue&type=script&lang=js&"
export * from "./staffTenTe.vue?vue&type=script&lang=js&"
import style0 from "./staffTenTe.vue?vue&type=style&index=0&id=78b39981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b39981",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
